import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./pages/Home";
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="35bsjd9muvsz1">
      <Routes data-id="element-1" data-mp="35eodsnzhvziq">
        <Route path="*" element={<Home data-id="element-3" data-mp="3k9ukzeabu4dn" />} data-id="element-2" data-mp="3k9kwxw8ue7al" />
      </Routes>
    </BrowserRouter>;
}